import Vue from 'vue';
import Router from 'vue-router';
import Projects from './views/GcpProjects.vue';
import Login from './views/Login.vue';
import store from './store'
import FirebaseProjects from "./views/FirebaseProjects";
import GcpProjects from "./views/GcpProjects";

Vue.use(Router);

function handleAuthentication(to, from, next) {
  const token = store.getters['authentication/token'];
  if (token) {
    next();
    return
  }
  next('/login');
}

function checkIfLoggedIn(to, from, next) {
  const token = store.getters['authentication/token'];
  if (token) {
    next('/');
    return
  }
  next();
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/gcp-projects',
      beforeEnter: handleAuthentication,
    },
    {
      path: '/gcp-projects',
      name: 'gcpProjects',
      component: GcpProjects,
      beforeEnter: handleAuthentication,
    },
    {
      path: '/firebase-projects',
      name: 'firebaseProjects',
      component: FirebaseProjects,
      beforeEnter: handleAuthentication,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: checkIfLoggedIn,
    },
    {
      path: '*',
      redirect: '/',
      beforeEnter: handleAuthentication,
    },
  ],
});
